import React from 'react'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { TaskTypeT } from 'shared/constants'
import { BUTTON_TYPE } from '../../constant'
import type { DeleteActionButtonProps } from '../../types'
import DeleteBody from './delete-body'
import DeleteFooter from './delete-footer'
import { getTaskTypeTexts } from './utils/get-task-type-texts'

export const getDeleteWorkflowButton = ({
  setDialogProps,
  t,
  buttonProps = {},
  handleButtonAction,
  task,
}: DeleteActionButtonProps) => {
  const { taskType } = task
  const { title, body: bodyText } = getTaskTypeTexts(taskType as TaskTypeT)

  return {
    onClick: () =>
      setDialogProps({
        // TODO: Update with more generic label
        title: t(title),
        footer: (
          <DeleteFooter
            onClick={() => handleButtonAction(BUTTON_TYPE.delete)}
            t={t}
            onClose={() => setDialogProps(undefined)}
          />
        ),
        content: <DeleteBody t={t} text={bodyText} />,
      }),
    label: t('button.deleteTask'),
    testId: 'task_detail_delete_task',
    variant: 'text',
    color: 'error',
    ...buttonProps,
  } as Action
}
